<template>
  <div style="margin-top: 17px">
    <div class="header">
      <div class="word2">
        请输入注册时使用的主要联络手机号，以查看您的申请记录。
      </div>
      <div class="word3">
        未提交申请记录一般会在1个月后删除，请尽快完成您的申请。
      </div>
    </div>
    <div class="section1 flex-col"></div>
    <a-form :form="form">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item>
            <div class="title">主要联络手机</div>
            <a-input
              v-decorator="[
                'mobile',
                {
                  rules: [{ validator: mobileRules }],
                  validateTrigger: 'blur',
                  getValueFromEvent: (event) => {
                    return /^\d+$/.test(event.target.value)
                      ? event.target.value
                      : ''
                  },
                },
              ]"
              placeholder="请输入您常用的手机号" :maxLength="11"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <div class="title">验证码</div>
          <a-form-item
            :labelCol="{ lg: { span: 1 } }"
            :wrapperCol="{ lg: { span: 15 } }"
          >
            <a-col :span="16">
              <a-input
                v-decorator="[
                  'smsCode',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^\d{6}$/,
                        message: '请输入验证码',
                      },
                    ],
                    getValueFromEvent: (event) => {
                      return /^\d+$/.test(event.target.value)
                        ? event.target.value
                        : ''
                    },
                  },
                ]"
                placeholder="请输入收到的验证码" :maxLength="6"
              />
            </a-col>
            <a-col :span="2">
              <a-button
                style="margin-left: 20px"
                @click.stop.prevent="getCode"
                >{{
                  this.state.time === 0 || this.state.time === 60
                    ? '获取验证码'
                    : `${this.state.time}s后再次发送`
                }}</a-button
              >
            </a-col>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="section4 flex-col"></div>
      <div class="outer9 flex-col"></div>
      <a-form-item>
        <a-button
          class="submit"
          type="primary"
          html-type="submit"
          @click="submit"
        >
          提交
        </a-button>
      </a-form-item>
    </a-form>
    <div class="apply" @click="last(5)">重新申请入驻</div>
  </div>
</template>
<script>
import bureau from '../../../api/bureau'
import user from '../../../api/user'
import { Modal } from 'ant-design-vue'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      state: {
        time: 60,
      },
      id: '',
    }
  },
  created() {
    bureau.getBureauId().then((res) => {
      this.id = res
    })
  },
  methods: {
    mobileRules(rule, value, callback) {
      if (!value) {
        callback('请输入常用的手机号')
      } else if (!/^[\u0030-\u0039]{11}$/.test(value)) {
        callback('请输入正确的手机号')
      }
      callback()
    },
    last(step) {
      this.$emit('lastStep', step)
      this.$store.commit('register/emptyRegister', {
        institutionType: 2,
        status: 0,
      })
    },
    submit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true
          this.$store.commit('register/changeInformation', {
            ...values,
            bureauId: this.id,
          })
          await user
            .queryingApplicationStatus({ ...values, bureauId: this.id })
            .then(async (res) => {
              console.log(res)
              this.$store.commit('register/changeInformation', res.data)
              this.$ls.set('token', res.data.accessToken)
              this.loading = false
              if (res.status === '1') {
                await user.getInformation().then((res) => {
                  console.log('res', res)
                  this.$store.commit('register/changeInformation', res.data)
                  this.$emit('lastStep', 2)
                })
                return
              } else if (res.status === '2' || res.status === '4') {
                this.$emit('lastStep', 1)
                return
              } else if (res.status === '3') {
                this.showModal()
                return
              }
            })
        }
      })
    },
    //审核成功，对话框提示
    showModal() {
      let _this = this
      const h = this.$createElement
      this.$info({
        title: '审核成功',
        content: h('div', {}, [h('p', '请至开放平台--自助管理进行登录')]),
        onOk() {
          _this.$router.push('login')
        },
      })
    },
    //发送验证码
    getCode(e) {
      e.preventDefault()
      this.form.validateFields(['mobile'], (err, values) => {
        if (!err) {
          if (60 > this.state.time > 0) {
            return
          }
          const hide = this.$message.loading('验证码发送中..', 0)
          user
            .getSmscode({
              mobile: values.mobile,
              mode: 'provider_regist_result',
            })
            .then((res) => {
              setTimeout(hide, 2500)
            })
            .catch((err) => {
              console.error('错误信息：', err)
              setTimeout(hide, 1)
              clearInterval(interval)
              this.state.time = 60
            })
          let timerId
          //发送请求，获取验证码
          timerId = window.setInterval(() => {
            this.state.time -= 1
            if (this.state.time === 0) {
              clearInterval(timerId)
              this.state.time = 60
            }
          }, 1000)
        } else {
          this.$refs.input.focus()
          return
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin: 16px 0 0 0;
  .word2 {
    margin-bottom: 10px;
  }
}
.section1 {
  z-index: 12;
  width: 1005;
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin-top: 31px;
}
.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin-top: 100px;
}

.section4 {
  z-index: 3;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 100px;
}
.submit {
  width: 140px;
  height: 42px;
  left: 45%;
  margin-top: 20px;
}
.apply {
  width: 84px;
  height: 20px;
  display: block;
  color: rgba(78, 148, 255, 1);
  font-size: 14px;
  text-decoration: underline;
  font-family: PingFangSC-Regular;
  line-height: 20px;
  margin-top: 32px;
  position: absolute;
  top: 100%;
  left: 47%;
}
</style>
